import React from "react";
import MovieCard from "./MovieCard";
import MovieCardShimmer from "./Shrimmers/MovieCardShimmer";

const MovieList = ({ title, movies }) => {
  const isLoading = !movies || movies.length === 0;

  return (
    <div className="mb-6 last:mb-0">
      <h1 className="text-neutral-100 text-xl md:text-3xl font-bold px-4 md:px-10 mb-4">
        {title}
      </h1>

      <div className="flex gap-2 md:gap-4 overflow-x-auto px-4 md:px-10 pb-2">
        {isLoading &&
          [...Array(8)].map((_, id) => <MovieCardShimmer key={id} />)}

        {!isLoading &&
          movies.map((movie) => (
            <MovieCard
              key={movie.id}
              movieId={movie.id}
              posterPath={movie.poster_path}
            />
          ))}
      </div>
    </div>
  );
};

export default React.memo(MovieList);
